import type { AvailableCommand } from '@agentclientprotocol/sdk';
import {
  SlashCommandAction,
  type SlashCommand,
} from '../../../slash_commands/slash_command_handler';

const COMPACT_COMMAND: AvailableCommand = {
  name: 'compact',
  description: 'Compress conversation history to save context space',
  input: { hint: 'what to focus on when summarising (optional)' },
};

const HINT_BY_ACTION: Partial<Record<string, string>> = {
  [SlashCommandAction.CustomCommand]: 'additional instructions (optional)',
  [SlashCommandAction.Skills]: 'goal (optional)',
};

/**
 * Builds the ACP `available_commands_update` list from the CLI's
 * headless-capable slash commands (custom commands, skills; see
 * `SlashCommandService#getHeadlessCommands`), plus `/compact`, which isn't
 * in that set since it forwards its literal text to the backend rather than
 * going through `toPrompt`. Command names drop their leading `/`, matching
 * the ACP `AvailableCommand.name` convention (e.g. `compact`, not `/compact`).
 */
export function buildAvailableCommands(headlessCommands: SlashCommand[]): AvailableCommand[] {
  const commands = headlessCommands.map((command) => {
    const hint = HINT_BY_ACTION[command.action];
    return {
      name: command.name.slice(1),
      description: command.description,
      ...(hint ? { input: { hint } } : {}),
    };
  });
  return [...commands, COMPACT_COMMAND];
}
